import React, { FC } from 'react';

type MatchObjectCellProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  // TODO: write types, if you have some free time please :)
  // entity: PropTypes.object.isRequired,
};

const MatchObjectCell: FC<MatchObjectCellProps> = ({ entity }) => {
  return (
    <li className="match-name ellipsis"
        data-test="match-name">
      {(entity && entity.name) || '–––'}
    </li>
  );
};

export default MatchObjectCell;
